import type React from 'react';
import FilterCategoriesTabComponent from 'src/Administration/Metadata/MetadataSortingAndFiltering/FilterCategoriesTab/FilterCategoriesTab';
import SortingOptionsTabComponent from 'src/Administration/Metadata/MetadataSortingAndFiltering/SortingOptionsTab/SortingOptionsTab';
import PreviewTabs from 'src/components/Tabs/PreviewTabs/PreviewTabs';
import TabPane from 'src/components/Tabs/TabPane/TabPane';
import styles from './MetadataSortingAndFilteringStyles';

const MetadataSortingAndFilteringComponent: React.FC = () => {
  const classes = styles();
  return (
    <div className={classes.tabWrapper}>
      <PreviewTabs>
        <TabPane name="Filter Categories" key="1">
          <FilterCategoriesTabComponent />
        </TabPane>
        <TabPane name="Sorting Options" key="2">
          <SortingOptionsTabComponent />
        </TabPane>
      </PreviewTabs>
    </div>
  );
};

export default MetadataSortingAndFilteringComponent;
